module.exports = __webpack_public_path__ + "static/media/placeholder-unavailable.f14351e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder-unavailable.svg
// module id = 341
// module chunks = 1